import * as React from "react";

import ComponentPage from "../../Components/ComponentPage";

import Examples from "../../Docs/Experimental/Accordion/AccordionExamples";
        
class Page extends React.Component {
public render() {
    return (
        <ComponentPage
            name="Accordion"
            description="The Accordion component shows one or more collapsible sections."
            apiSources={["azure-devops-ui-experimental/Components/Accordion/Accordion.Props.d.ts"]}
            examples={Examples}
            status={{"design":"Planned (Q3)","code":"Planned (Q3)","docs":"Planned (Q3)"}}
        />
    );
}
}
        
export default Page;